import { FIELD_TYPE } from "v2/constants/extractionReview";
import type { ReviewFieldValueType } from "v2/types/extractionReview.types";
import { renderReviewValue } from "v2/utils/renderReviewValue";
import dayjs from "dayjs";
import { formatDate } from "utils/formatDate";

// Render a scalar honouring its declared type — dates go through the shared formatDate
// (DISPLAY_DATE); anything not a valid date falls back to the plain renderer.
export const renderTypedValue = (
  value: unknown,
  type: ReviewFieldValueType
): string => {
  if (
    type === FIELD_TYPE.DATE &&
    typeof value === "string" &&
    dayjs(value).isValid()
  ) {
    return formatDate(value);
  }
  return renderReviewValue(value);
};
